import { Controller } from '@hotwired/stimulus';

// A title-only / short Intro & News card must not show a scrollbar. Desktop
// browsers use space-consuming scrollbars and `overflow-y: auto` renders one for
// even a fractional (Retina) overflow, so the card defaults to
// `overflow-y: hidden` (see intro_news.scss) and we opt into scrolling only when
// the content truly exceeds the card's max-height. Re-checked on resize because
// the max-height is viewport-relative (vh).
export default class extends Controller {
  connect() {
    this.update = this.update.bind(this);
    requestAnimationFrame(this.update);
    window.addEventListener('resize', this.update);
  }

  disconnect() {
    window.removeEventListener('resize', this.update);
  }

  update() {
    const overflows = this.element.scrollHeight - this.element.clientHeight > 1;
    this.element.classList.toggle('intro-news-card--scrollable', overflows);
  }
}
